// For Webkit: 'page:change' is being fired on the initial page load *before* the body's 'ready' event is,
// so queue it here to ensure that `pp.global.handlePageChangeEvent` is being called on page load.
$(document).one("page:change", () => {
	pp.global.pageLoadChangeEventQueued = true;
});

/**
 * set all global listeners once after the document has loaded
 */
$("body").ready((event) => {
	pp.log("GLOBAL body initialized -- location:", window.location.pathname);

	pp.global.setupGlobalEventListeners();
	// @ts-expect-error
	pp.tabbedModules = new pp.Tabifier();
	// @ts-expect-error
	pp.tabbedModules.setupListeners();
	pp.activities.observeChange(
		"unreadActivitiesData",
		pp.activities.debounceUnreadStates,
	); // update navbar unread state when hash has changed
	pp.activities.observeChange(
		"pullActivitiesQueue",
		pp.activities.setPullActivityTimeout,
	);
	pp.viewHelpers.detectViewportBreakpointChange.init();
	// @ts-expect-error
	pp.loaderHtml =
		'<div class="lds-ring"><div></div><div></div><div></div><div></div></div>';

	if ($("#fixed-bottom-banner").length) {
		pp.global.checkCookieAcknowledgement();
	}

	// listen for attempt to change page when there's unsaved text and intercept if necessary
	pp.pageChangeConfirm.init();

	// initialize listener to send Chat Message on enter
	pp.chat.sendMessagesOnEnterListener();
	pp.global.overlayListeners.init();
	pp.global.emulateMethodLinksFormBehavior.initAjaxListener();

	// Somehow Turbolinks' `page:change` event is not triggered on page load on Safari, so make extra sure that unread Activities are being fetched
	setTimeout(() => {
		if (pp.activities.fetchedInPhaseNumer == null && $("nav.navbar").length) {
			pp.activities.fetchAllUnreadActivities();
		}
	}, 250);
});

/**
 *	container for all global functions
 */
export default {
	setupGlobalEventListeners() {
		$(document).on("page:change", pp.global.handlePageChangeEvent);

		// Listen for custom event and set navbar dropdown and group members dropdown (if existing)
		pp.vue.bus.$on("game-actors-UPDATE", pp.stickyButtons.setOnlineActorsList);

		// @ts-expect-error
		PrivatePub.observeChange("state", pp.global.handlePrivatePubStateChange);

		pp.navigation.initGlobalListeners();
		pp.viewHelpers.enhanceModalFunctionality.init();

		pp.viewHelpers.preventPasteAction();
		pp.viewHelpers.pausePlayingVideosOnAnyModalClose.init();
		$(document).on("page:before-change", ({ target }) => {
			pp.log("GLOBAL page:before-change triggered -- target url:", target.URL);
		});

		// let a.button tags with disable_with attributes and POST or PUT methods behave like the respective buttons
		$(document).on(
			"click",
			"a[data-disable-with][data-method]:not([href='javascript:;']):not([href^='#'])",
			function () {
				const storedHref = $(this).attr("href");
				$(this).addClass("disabled").removeAttr("href");
				if ($(this).data("remote") === void 0) {
					// @ts-expect-error
					Turbolinks.visit(storedHref);
				}
			},
		);

		// Stop clicks (i.e inside accordion headings) from bubbling up
		$(document).on("click", ".j-prevent-event-bubble-up", (event) => {
			event.stopPropagation();
		});

		$(document).on("click", ".FlashMessage__dismiss", function () {
			pp.notifications.animateFadeOut(
				$(this).parent(".FlashMessage"),
				undefined,
				100,
			);
		});

		$(document).on("click", ".j-save-tracked-data", ({ currentTarget }) => {
			const $target = $(currentTarget);
			$.post("/activities/save_tracked_information", {
				append_to_tracked_data_key: $target.data("tracked-data-key"),
				append_to_tracked_data_value: $target.data("tracked-data-value"),
			});
		});

		// load Quizzes that have a "hidden" link in
		$(document).on("click", "a[data-quiz-name]", function (e) {
			let $btn = $(this);
			// @ts-expect-error
			$btn.append(pp.loaderHtml);
			$("#quiz-modal").one("shown.bs.modal", () => {
				$btn.find(".lds-ring").remove();
			});
			e.preventDefault();
			pp.quiz.loadAndDisplayQuiz({ name: $(this).data("quiz-name") });
		});

		/**
		 * watch for language changes and update timeago's and numberal.js' language accordingly
		 * do this before the body is fully loaded so that the initial setting of I18n.locale will be recognized
		 */
		if (typeof I18n !== "undefined") {
			// @ts-expect-error
			I18n.observeChange("locale", (oldval, newval) => {
				if (newval === undefined) return;

				// NB timeago and numeral don't know region-specific language codes (like 'es-419'), so shorten those to the first two characters
				// @ts-expect-error
				jQuery.timeago.settings.lang = newval.substring(0, 2);
				// @ts-expect-error
				numeral.language(newval.substring(0, 2));
				$("html").prop(
					"dir",
					I18n.translate("meta.direction", {
						locale: newval,
						defaultValue: "ltr",
					}),
				);
			});
		}

		// Validate newly loaded forms and show the baked-in error messages from forms that are shown for invalid records
		$(document).on("page:change ajax:success", () => {
			setTimeout(() => {
				$("form[data-validate]").validate();
				$(".Field-with-errors input").trigger("element:validate:fail");
			}, 500);
		});

		if ($("body").hasClass("moderator-view")) {
			pp.backend.modModalNavigation.setupListeners();
		}

		// See comment above
		setTimeout(() => {
			if (pp.global.pageLoadChangeEventQueued === undefined) {
				return;
			}
			pp.global.handlePageChangeEvent();
			if (pp.backend) {
				pp.backend.handlePageChangeEvent();
			}
		}, 25);
	},

	handlePageChangeEvent(event) {
		pp.log(
			"GLOBAL page:change triggered -- target url:",
			event ? event.target.URL : "(no event)",
		);

		// when a page is changed and it's done via AJAX, listen for the ajax event to finish and see if there's a page title in the header
		// avoid changing the page title on every AJAX request this way
		$(document).one("ajaxComplete", (event, request) => {
			let responseXHeader = request.getResponseHeader("X-Header");
			if (responseXHeader === undefined || responseXHeader === null) {
				return;
			}
			responseXHeader = JSON.parse(responseXHeader);
			document.title = new DOMParser().parseFromString(
				responseXHeader.join(" | "),
				"text/html",
			).documentElement.textContent;
			// Only used for mod area and CMS
			$(".mobile-page-title").text(
				decodeURIComponent(encodeURIComponent(responseXHeader[0])),
			);
		});

		if ($("nav.navbar").length) {
			pp.stickyButtons.setOnlineActorsList(); // Re-set online Actors list when page has changed
			pp.activities.setNestedLinksUnreadStates();
			pp.activities.fetchAllUnreadActivities();
			pp.navigation.initOneOffHints();
			if ($("#navbar-collapse.in").length) {
				// @ts-expect-error
				$("#navbar-collapse").collapse("hide");
				$(window).scrollTop(0);
			}
			if (pp.viewHelpers.isBreakpointOfSize(">gridFloatBreakpoint")) {
				// init popovers for disabled navbar elements
				$(
					"ul.navbar-nav a.disabled, div.navbar-header.disabled a.navbar-brand",
					// @ts-expect-error
				).popover({
					placement: "bottom",
					trigger: "hover",
					template:
						'<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
				});
			}
		}

		pp.global.emulateMethodLinksFormBehavior.prepareLinks();

		// set all textareas that are not in the backend to autosize
		$("textarea:not(div.field > textarea):visible")
			.not(".j-autosize-disabled")
			// @ts-expect-error
			.autosize();
		// @ts-expect-error
		$("a.popover-action[data-content], [data-toggle='popover']").popover(); // init all helper popovers

		pp.vueHooks.bindClickHooks();

		// @ts-expect-error
		if (PrivatePub.state == PrivatePub.DISCONNECTED) {
			pp.notifications.display(
				"notification_banner",
				I18n.t("private_pub.faye_connection_lost"),
				{
					showBar: true,
				},
			);
			// @ts-expect-error
		} else if (PrivatePub.state == PrivatePub.SCRIPT_UNREACHABLE) {
			pp.notifications.display(
				"notification_banner",
				I18n.t("private_pub.faye_unreachable"),
				{
					showBar: true,
				},
			);
		}

		$(document).on("bootstrap:breakpoint-changed", () => {
			if (pp.viewHelpers.isBreakpointOfSize("xs")) {
				pp.viewHelpers.decorateHorizontallyScrollingEls();
			}
			if (pp.viewHelpers.isBreakpointOfSize("<=sm")) {
				pp.viewHelpers.linkRtfInfoImages();
			}
		});

		// Listen to clicks on those elements (which are labels) and check their (nested!) checkbox manually, somehow bootstrap's data-toggle prevents that
		$(".j-radio-pane-switcher[data-toggle]").on(
			"shown.bs.tab",
			function (event) {
				// Cancel event if the target radio input is disabled
				if ($(this).find("input").prop("disabled")) {
					return;
				}
				$(this).find("input").prop("checked", true);

				pp.global.initSelect2For($($(this).data("target")).find("select"));
			},
		);

		$(".j-radio-pane-switcher input[type=radio]").on("click", (e) => {
			e.preventDefault();
			e.stopPropagation();
			setTimeout(() => {
				$(".j-radio-pane-switcher input[type=radio]").prop("checked", false);
				$(e.target).parent().trigger("click");
			}, 10);
		});

		pp.viewHelpers.dependentInputs.init();

		// For Webkit, see comment above
		delete pp.global.pageLoadChangeEventQueued;
	},

	/**
	 * listen to custom faye status triggers from the customized private pub JS
	 * PrivatePub states: 1 = CONNECTING, 2 = SCRIPT_UNREACHABLE, 3 = SCRIPT_LOADED, 4 = CONNECTED, 5 = DISCONNECTING, 6 = DISCONNECTED
	 * fayeClient states: 1 = UNCONNECTED, 2 = CONNECTING, 3 = CONNECTED, 4 = DISCONNECTED
	 * faye dispatcher states: 1 = UP, 2 = DOWN
	 */
	handlePrivatePubStateChange(oldval, newval) {
		pp.log(
			"GLOBAL into handlePrivatePubStateChange -- old, new:",
			oldval,
			newval,
		);
		// @ts-expect-error
		if (newval == PrivatePub.DISCONNECTED) {
			pp.log(
				"FAYE connection loss -- client state, client dispatcher state, latest connection to server:",
				// @ts-expect-error
				PrivatePub.fayeClient._state,
				// @ts-expect-error
				PrivatePub.fayeClient._dispatcher._state,
				// @ts-expect-error
				PrivatePub.latestConnectionToServer || "(null)",
			);

			let msg;
			let colorClass;
			// this combination typically means that no connection could be established after page load
			if (
				// @ts-expect-error
				PrivatePub.fayeClient._state == PrivatePub.fayeClient.CONNECTING &&
				// @ts-expect-error
				PrivatePub.fayeClient._dispatcher._state ==
					// @ts-expect-error
					PrivatePub.fayeClient._dispatcher.DOWN
			) {
				msg = I18n.t("private_pub.faye_unreachable");
				colorClass = "orange";
			}
			// the typical combination of states is fayeClient._state = CONNECTED, dispatcher._state = DOWN,
			// meaning that there was an active connection but it was lost
			// check first if last incoming message from the server was more 50 seconds ago (normal interval of 25 seconds times 2)
			else if (
				// @ts-expect-error
				PrivatePub.latestConnectionToServer !== null &&
				// @ts-expect-error
				PrivatePub.latestConnectionToServer <
					Math.floor(new Date().getTime() / 1000) - 50
			) {
				// @ts-expect-error
				PrivatePub.latestConnectionToServer = null;
				// pp.log("returning from sleep(?)");
				msg = I18n.t("private_pub.faye_reestablishing_connection");
				colorClass = "green";
			} else {
				msg = I18n.t("private_pub.faye_connection_lost");
				colorClass = "orange";
			}

			pp.notifications.display("notification_banner", msg, {
				showBar: true,
				colorClass: colorClass,
			});
			return;
		}

		// Else -- if there is no fayeClient it means that the faye.js script is unreachable and the script.onload was not triggered in private_pub_custom.js
		// @ts-expect-error
		if (newval == PrivatePub.SCRIPT_UNREACHABLE) {
			pp.log("FAYE could not load faye.js file");
			pp.notifications.display(
				"notification_banner",
				I18n.t("private_pub.faye_unreachable"),
				{
					showBar: true,
					colorClass: "orange",
				},
			);
			return;
		}

		// Else
		if (
			// @ts-expect-error
			(oldval == PrivatePub.SCRIPT_UNREACHABLE &&
				// @ts-expect-error
				newval == PrivatePub.SCRIPT_LOADED) ||
			// @ts-expect-error
			(oldval == PrivatePub.DISCONNECTED && newval == PrivatePub.CONNECTED)
		) {
			// @ts-expect-error
			if (newval == PrivatePub.CONNECTED) {
				pp.log(
					"FAYE connection back up -- client state, dispatcher state, latest connection to server:",
					// @ts-expect-error
					PrivatePub.fayeClient._state,
					// @ts-expect-error
					PrivatePub.fayeClient._dispatcher._state,
					// @ts-expect-error
					PrivatePub.latestConnectionToServer || "(null)",
				);
			} else {
				pp.log("FAYE script load succeeded after initial attempt failed");
			}

			pp.notifications.display(
				"notification_banner",
				I18n.t("private_pub.faye_back_up"),
				{ showBar: false, colorClass: "green" },
			);

			// admins can be subscribed to Private Pub for the unionslabor stats page, so make sure to only call /activities/rerender_latest_game_state
			// if there is a current Actor (for moderators and logged-in Actors)
			if (!$("body").hasClass("moderator-view")) {
				return;
			}

			// trigger the rails server to re-render faye feeds and send them to this Actor only.
			// there might be messages in the faye pipeline if the connection was lost for just a few seconds, so give those
			// a 2.5s head start to avoid doule rendering
			setTimeout(
				"pp.gameState.fetchLatestGameState({pullActivities: true})",
				2500,
			);
		}
	},

	/**
	 * Check with JS if the use of cookies has been achknowledged and if not, show a consent banner
	 */
	checkCookieAcknowledgement() {
		// @ts-expect-error
		if (!Cookies.get("cookieConsent")) {
			$("#cookie-consent-banner").removeClass("hidden");
			$("#j-acknowledge-cookies").one("click", () => {
				// @ts-expect-error
				Cookies.set("cookieConsent", true, {
					expires: 365,
				});
				$("#cookie-consent-banner").animate(
					{
						opacity: 0,
					},
					500,
					function () {
						$(this).addClass("hidden");
					},
				);
			});
		}
	},

	overlayListeners: {
		init() {
			if (bowser.mobile || bowser.tablet) {
				return;
			}

			$(document)
				.on("mouseenter", ".OverlayContainer", (event) => {
					const $container = $(event.currentTarget);
					const $overlay = $container.find(".OverlayContainer__content");
					if (!$overlay.length) {
						pp.log(
							"could not find `.OverlayContainer__content` for container",
							$container,
						);
						return;
					}
					pp.global.overlayListeners.setPosition($container, $overlay);
					// Listen to `mouseenter` on the overlay itself, and prevent it from disappearing with below global `mouseleave` event from the containing element.
					// Rather make it disappear when the mouse leaves the overlay itself.
					$overlay.one("mouseenter", function () {
						$(this).addClass("OverlayContainer__content--mouseover");
						$(this).one("mouseleave", function () {
							const that = this;
							setTimeout(() => {
								pp.global.overlayListeners.hideOverlay($(that));
							}, 150);
						});
					});
				})
				.on("mouseleave", ".OverlayContainer", (event) => {
					const $container = $(event.currentTarget);
					setTimeout(() => {
						if (
							$container
								.find(".OverlayContainer__content")
								.hasClass("OverlayContainer__content--mouseover")
						) {
							return;
						}
						pp.global.overlayListeners.hideOverlay(
							$container.find(".OverlayContainer__content"),
						);
					}, 150);
				});

			document.addEventListener(
				"scroll",
				_.debounce(pp.global.overlayListeners.hideOverlaysOnScroll, 500, {
					leading: true,
					trailing: false,
				}),
				true,
			);
		},

		hideOverlaysOnScroll() {
			$(".OverlayContainer__content--visible").each((idx, overlay) => {
				$(overlay).closest(".OverlayContainer").trigger("mouseleave");
			});
		},

		hideOverlay($overlay) {
			$overlay.removeClass(
				"OverlayContainer__content--visible OverlayContainer__content--mouseover",
			);
			setTimeout(() => {
				$overlay.css({ left: "", top: "" });
			}, 150); // Corresponds to `transition-duration` for .OverlayContainer__content
		},

		setPosition($container, $overlay) {
			const containerOffset = $container.offset();
			// Is not defined for non-rtl languages
			containerOffset.horizontal =
				I18n.t("meta.direction") == "rtl"
					? window.innerWidth - $container[0].getBoundingClientRect().right
					: containerOffset.left;
			// pp.log("overlayListeners into setPosition -- container, overlay, containerOffset", $container, $overlay, containerOffset);
			const overlayWidth = $overlay.outerWidth();
			const $parentForOffset =
				$overlay.parent().scrollParent()[0] != document
					? $overlay.parent().scrollParent()
					: $overlay.parent(); // Catch the case where the scrollParent defaults up to the document
			const offsetParentHorizontalOffset =
				I18n.t("meta.direction") == "rtl"
					? window.innerWidth -
						$parentForOffset[0].getBoundingClientRect().right
					: $parentForOffset.offset().left;
			let overlayHorizontalPosition;
			let overlayTopPosition =
				// @ts-expect-error
				containerOffset.top - $(window).scrollTop() + $container.innerHeight(); // Place overlay directly underneath the calling element
			const overlayHeightOutofLowerWindowBounds =
				containerOffset.top -
					// @ts-expect-error
					$(window).scrollTop() +
					$container.innerHeight() +
					$overlay.outerHeight() >
				// @ts-expect-error
				$(window).height();

			if (overlayHeightOutofLowerWindowBounds) {
				overlayTopPosition =
					// @ts-expect-error
					containerOffset.top - $(window).scrollTop() - $overlay.outerHeight();
				// Check if overlay would protrude over the top of the window
				if (overlayTopPosition < 0) {
					const navVisible =
						// @ts-expect-error
						$(document).scrollTop() < $(".navbar:visible").outerHeight();
					// Place either directly under the navbar if visible, or as far up as possible (i.e. 0px)
					overlayTopPosition = navVisible
						? // @ts-expect-error
							$(".navbar:visible").outerHeight() - $(document).scrollTop()
						: 0;
				}
			}

			if ($container.hasClass("OverlayContainer--right")) {
				overlayHorizontalPosition =
					containerOffset.horizontal + $container.width();

				// Use `border-top-left-radius` as a proxy for `border-radius`, which `.css()` won't detect
				if ($container.css("border-top-left-radius") == "50%") {
					// height and width should conceivable always be equal of the border radiis if 50%
					const rightTrinangleHypothenuseLength = Math.sqrt(
						Math.pow($container.width(), 2) + Math.pow($container.height(), 2),
					);
					const relationCircleWidthToHypothenuse =
						$container.width() / rightTrinangleHypothenuseLength;
					overlayHorizontalPosition =
						overlayHorizontalPosition -
						$container.width() * relationCircleWidthToHypothenuse +
						$container.width() / 2;
					overlayTopPosition =
						overlayTopPosition -
						$container.height() * relationCircleWidthToHypothenuse +
						$container.height() / 2;
				}
			}
			if (
				containerOffset.horizontal +
					$container.innerWidth() +
					overlayWidth -
					$overlay.parent().scrollParent().scrollLeft() >
				$overlay.parent().scrollParent()[0].scrollWidth +
					offsetParentHorizontalOffset
			) {
				overlayHorizontalPosition =
					containerOffset.horizontal + $container.innerWidth() - overlayWidth;
				if (overlayHorizontalPosition + overlayWidth > window.innerWidth) {
					overlayHorizontalPosition = containerOffset.horizontal;
				} else if (overlayHorizontalPosition < 0) {
					overlayHorizontalPosition = 0;
				}
			} else if (overlayHorizontalPosition === undefined) {
				overlayHorizontalPosition = containerOffset.horizontal;
				if (overlayHorizontalPosition < 0) {
					overlayHorizontalPosition = 0;
				}
			}
			// Else the overlay's left position will default to the left inner bound of the calling element

			// If there is a modal as the parent then adjust
			const $modalParent = $container.parents(".modal-dialog");
			if ($modalParent.length) {
				overlayTopPosition =
					overlayTopPosition -
					$modalParent.offset().top +
					// @ts-expect-error
					$(window).scrollTop();
				overlayHorizontalPosition =
					overlayHorizontalPosition -
					$modalParent.offset().left +
					// @ts-expect-error
					$(window).scrollLeft();
			}
			const cssArgs = { top: overlayTopPosition };
			cssArgs[I18n.t("meta.direction") == "rtl" ? "right" : "left"] =
				overlayHorizontalPosition;
			// pp.log("cssArgs", cssArgs);
			$overlay.addClass("OverlayContainer__content--visible").css(cssArgs);
		},
	},

	starRatingFields: {
		hoverListener(containerSelector) {
			// pp.log("STAR RATING hover listener init", containerSelector);
			$(containerSelector)
				.find("span.j-star")
				.on("mouseover", function () {
					// There are two actor phase feedback forms (on standalone, one in the phase change modal), so make sure to work on the right one
					const $thisForm = $(this).closest("form");
					const thisIndex = $thisForm.find("span.j-star").index(this);
					$thisForm
						.find(`span.j-star:lt(${thisIndex + 1})`)
						.removeClass("senaryon-icon senaryon-icon-rating-star-empty")
						.addClass("senaryon-icon senaryon-icon-rating-star");
					$thisForm
						.find(`span.j-star:gt(${thisIndex})`)
						.removeClass("senaryon-icon senaryon-icon-rating-star")
						.addClass("senaryon-icon senaryon-icon-rating-star-empty");
					$(this).one("click", pp.global.starRatingFields.clickListener);
				})
				.on("mouseout", function () {
					$(this).off("click", pp.global.starRatingFields.clickListener);
					const $thisForm = $(this).closest("form");
					let selectedRating = $thisForm
						.find("input.j-star-rating-target")
						.val();
					// pp.log("rating:", selectedRating, parseInt(selectedRating, 10));
					if (selectedRating == "") {
						$thisForm
							.find("span.j-star")
							.removeClass("senaryon-icon senaryon-icon-rating-star active")
							.addClass("senaryon-icon senaryon-icon-rating-star-empty");
					} else {
						// @ts-expect-error
						selectedRating = parseInt(selectedRating, 10);
						$thisForm
							.find(`span.j-star:lt(${selectedRating})`)
							.removeClass("senaryon-icon senaryon-icon-rating-star-empty")
							.addClass("senaryon-icon senaryon-icon-rating-star active");
						$thisForm
							.find(`span.j-star:gt(${selectedRating - 1})`)
							.removeClass("senaryon-icon senaryon-icon-rating-star")
							.addClass("senaryon-icon senaryon-icon-rating-star-empty");
					}
				});
		},

		clickListener() {
			// there are two actor phase feedback forms (on standalone, one in the phase change modal), so make sure to work on the right one
			const $thisForm = $(this).closest("form");
			// @ts-expect-error
			const thisIndex = $thisForm.find("span.j-star").index(this);
			// pp.log(thisIndex, $thisForm);
			$thisForm.find("input.j-star-rating-target").val(thisIndex + 1);
			$thisForm.find(`span.j-star:lt(${thisIndex + 1})`).addClass("active");
			$thisForm.find(`span.j-star:gt(${thisIndex})`).removeClass("active");
		},
	},

	/**
	 * prepend the given string (rendered from the dashboard_activity partial) into the activity feed if present
	 */
	prependToActivityFeed(htmlString) {
		const $elem = $(htmlString);
		$elem.hide().prependTo("#activity-feed").fadeIn("slow");
		pp.vue.mountElementsInContainer($elem); // For the avatar
	},

	/**
	 * Wrapper for the jquery select2 plugin
	 */
	initSelect2For($elems, preventCloseOnSelect) {
		if (preventCloseOnSelect === undefined) {
			preventCloseOnSelect = false;
		}
		// pp.log("GLOBAL init select2 -- elements, caller", $elems, (new Error()).stack.split("\n")[1]);
		$elems.each(function () {
			// Declare this here so that escapeMarkup function has access to the data attr
			// @ts-expect-error
			const $thisSelectElem = $(this);
			// @ts-expect-error
			$thisSelectElem.select2({
				minimumResultsForSearch: $thisSelectElem.data("tag")
					? undefined
					: Infinity,
				closeOnSelect: !preventCloseOnSelect,
				// @ts-expect-error
				width: this.multiple ? "99%" : "resolve",
				tags: $thisSelectElem.data("tag") !== undefined,
				escapeMarkup(itemText) {
					const $option = $thisSelectElem.children(`:contains('${itemText}')`);
					// pp.log("option", $option, $option.attr('data-overlay'));
					// don't check for $option.data('overlay'), select2 adds it's own differently structured data to the option
					if (
						$option.length &&
						$option.attr("data-overlay") !== undefined &&
						// @ts-expect-error
						$option.attr("data-overlay").length
					) {
						return `<div class='OverlayContainer OverlayContainer--right'>\
							${itemText}
							<div class='OverlayContainer__content'>${$option.attr("data-overlay")}</div>\
						</span>`;
					} else {
						return itemText;
					}
				},
			});
			// Always remove the "title" attribute, it's useless
			$thisSelectElem.next("span.select2").find("li").removeAttr("title");
			$thisSelectElem.on("change", ({ target }) => {
				$(target).next("span.select2").find("li").removeAttr("title");
			});
			// If the select options are supposed to trigger some Bootstrap element (e.g. tab panes)
			// we have to trigger 'click' on the selected option, so that Bootstrap gets wind of it
			$thisSelectElem.on("select2:select", ({ target }) => {
				if (
					$(target).find("option:selected").attr("data-target") !== undefined
				) {
					$(target).find("option:selected").trigger("click");
				}
			});
			// Show the "tag" (i.e. the content from the ArticleTemplateGapOption) as the placeholder in the searchbox
			if ($thisSelectElem.data("tag") !== undefined) {
				$thisSelectElem.on("select2:open", (event) => {
					$(".select2-search__field").attr(
						"placeholder",
						$thisSelectElem.data("tag"),
					);
				});
			}

			// No need to hack the width for multiselect boxes
			if ($thisSelectElem.data("select2").options.options.multiple) {
				// add arrow to multiselect
				$(".select2-selection--multiple").append(
					'<span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>',
				);
				return; // continue for jQuery
			}

			// Store the calculated width and then set it to 0, so that the container won't be expanded due to too wide boxes
			// in the next loop the calculated width will be restored, or reset so that the element will fit into the container
			const $renderedSelect = $thisSelectElem.data("select2").$container;
			$renderedSelect.data("calculatedWidth", $renderedSelect.outerWidth());

			$renderedSelect.outerWidth(0);
		});

		$elems.each(function () {
			// @ts-expect-error
			const $thisSelectElem = $(this);
			const $renderedSelect = $thisSelectElem.data("select2").$container;
			const calculatedWidth = $renderedSelect.data("calculatedWidth");
			const parentWidth = $renderedSelect.parent().width();

			if (calculatedWidth === undefined) return; // continue for jQuery

			// 48px is an approximation for the extra width from padding that select2 needs
			// `parentWidth == 0`catches the case where the select element is nested in an absolutely positioned element,
			// which will have no with without the select element itself
			if (calculatedWidth + 48 < parentWidth || parentWidth == 0) {
				$renderedSelect.outerWidth(calculatedWidth + 48);
			} else {
				$renderedSelect.outerWidth(parentWidth);
			}
		});
	},

	autoloadPagination($scrollElem) {
		// pp.log("setting autoloadPagination for", $scrollElem);
		// `document` has no css styles
		const paddingTop = !$scrollElem.is(document)
			? parseInt($scrollElem.css("padding-top"), 10)
			: 0;
		const paddingBottom = !$scrollElem.is(document)
			? parseInt($scrollElem.css("padding-bottom"), 10)
			: 0;
		$scrollElem.scroll(function () {
			if (!$scrollElem.find("nav.pagination").find("a.next").length) {
				return;
			}

			let $link;
			let $loadingRing;

			// pp.log("autoloadPagination data", $scrollElem[0].scrollTop, $scrollElem.height(), $scrollElem[0].scrollHeight, paddingTop, paddingBottom);
			// If the pagination goes backwards and the dynamically loaded elements are inserted on top
			if ($scrollElem.find("nav.pagination").hasClass("up")) {
				if ($scrollElem[0].scrollTop == 0) {
					$link = $scrollElem.find("a.next");
					$loadingRing = $scrollElem.find(".lds-ring");
				}
			} else if (
				$scrollElem[0] == $(document)[0] &&
				// @ts-expect-error
				$(window).scrollTop() + $(window).height() == $(document).height()
			) {
				$link = $("nav.pagination").find("a.next");
				$loadingRing = $("nav.pagination").find(".lds-ring");
			} else if (
				$scrollElem[0] != document &&
				Math.ceil($scrollElem[0].scrollTop + $scrollElem.height()) ==
					$scrollElem[0].scrollHeight - paddingTop - paddingBottom
			) {
				$link = $scrollElem.find("a.next");
				$loadingRing = $scrollElem.find(".lds-ring");
			}

			if (!$link && !$loadingRing) {
				return;
			}

			$link.trigger("click").prop("disabled", true).hide();
			$loadingRing.removeClass("hidden");
		});

		// Activity feed can be empty on load if the first 10 Activities are all Message Ratings, which are filtered out in _dashboard_activity
		if (
			$scrollElem.children().length == 1 &&
			$scrollElem.children("nav.pagination")
		) {
			$scrollElem.trigger("scroll");
		}
	},

	securelyReplaceDOMElemContent($element, newInnerHtml, newOuterClasses) {
		$element.html(newInnerHtml);
		if (newOuterClasses !== undefined) {
			$element.attr("class", newOuterClasses);
		}
	},

	addBrowserHistoryEntry(url) {
		if (history.pushState === undefined) {
			return;
		}

		history.pushState(
			{
				turbolinks: true,
				url: url,
			},
			"",
			url,
		);
	},

	emulateMethodLinksFormBehavior: {
		untreatedLinkSelector:
			"a[href][data-method='put']:not([href='javascript:;']):not([href^='#']),\
			a[href][data-method='post']:not([href='javascript:;']):not([href^='#']),\
			a[href][data-method='delete']:not([href='javascript:;']):not([href^='#'])",

		initAjaxListener() {
			// pretty bad hack to make sure that all inserted links from any request (even those that don't trigger 'page:change') will be handled
			$(document).on("ajaxComplete", (event, { responseText }) => {
				if (
					typeof responseText == "string" &&
					responseText.length &&
					responseText != "{}"
				) {
					pp.global.emulateMethodLinksFormBehavior.prepareLinks();
				}
			});
		},
		prepareLinks() {
			// pp.log("GLOBAL emulateMethodLinksFormBehavior preparing links -- elements", $(this.untreatedLinkSelector));
			$(this.untreatedLinkSelector).each(function () {
				const $link = $(this);
				// pp.log("at link", $link)

				// @ts-expect-error
				$link.attr("data-stored-href", $link.attr("href")).removeAttr("href");
				$link.on(
					"click",
					pp.global.emulateMethodLinksFormBehavior.handleLinkClick,
				);

				// @ts-expect-error
				if ($._data(this, "events").click.length > 1) {
					// @ts-expect-error
					const eventHandlers = $._data(this, "events").click;
					eventHandlers.unshift(eventHandlers.pop()); // Take the just appended handler (i.e. `handleLinkClick`) and add it as the first
					// @ts-expect-error
					$._data(this, "events").click = eventHandlers;
				}
			});
		},
		handleLinkClick({ currentTarget }) {
			// pp.log("GLOBAL emulateMethodLinksFormBehavior handling click -- target", event.currentTarget);
			const $link = $(currentTarget);

			// the stored href might have been removed from somewhere else if the link got disabled
			if (
				$link.attr("data-stored-href") === undefined ||
				// @ts-expect-error
				!$link.attr("data-stored-href").length
			)
				return;

			// @ts-expect-error
			$link.attr("href", $link.attr("data-stored-href"));
			// show the confirm modal, it will remove `href` again after confirmation (via `handleRailsLink` below)
			if ($link.data("confirm") !== undefined) {
				return true;
			}
			// If there are other listeners for this element, let them do their thing and then remove `href` again
			// @ts-expect-error
			else if ($._data($link.get(0), "events").click.length > 1) {
				setTimeout(() => {
					$link.removeAttr("href");
				}, 500);
				return true;
			}
			// default: handle the link and remove the `href` again
			else {
				pp.global.handleRailsLink($link);
				$link.removeAttr("href");
				return false;
			}
		},
	},

	handleRailsLink($link) {
		// pp.log("GLOBAL handleRailsLink:", $link);
		// @ts-expect-error
		if ($link.is($.rails.linkDisableSelector)) {
			// @ts-expect-error
			$.rails.disableElement($link);
		}

		if ($link.data("remote") !== void 0) {
			// @ts-expect-error
			const handleRemote = $.rails.handleRemote($link);
			// add special class so that cancelLinkExecution won't block rails.enableElement here
			$link.addClass("j-handling-with-rails");
			// response from rails.handleRemote() will either be false or a deferred object promise.
			if (handleRemote === false) {
				// @ts-expect-error
				$.rails.enableElement($link);
			} else if (handleRemote.statusText == "canceled") {
				Turbolinks.visit($link.attr("href"));
			} else {
				handleRemote.error(() => {
					// @ts-expect-error
					$.rails.enableElement($link);
				});
			}
			$link.removeClass("j-handling-with-rails");
		} else if ($link.data("method")) {
			// @ts-expect-error
			$.rails.handleMethod($link);
		} else if ($link.attr("type") == "submit") {
			if ($link.is("form")) {
				$link.submit();
			} else {
				$link.closest("form").submit();
			}
		} else {
			if (
				$link.attr("href").startsWith("#") &&
				$link.attr("data-toggle") !== undefined
			) {
				// Attempt to activate the Bootstrap target
				const bootstrapMethodToCall = $link.data("toggle");
				$link[bootstrapMethodToCall]("show");
			} else {
				// Just follow the link
				Turbolinks.visit($link.attr("href"));
			}
		}

		if (
			$link.data("method") !== undefined &&
			$link.data("confirm") !== undefined
		) {
			$link.removeAttr("href");
		}
	},
};
